import { labelChangeStatus } from './changeLabels';

export type ChangeSubtaskGateStatus =
  | 'off'
  | 'avaliar'
  | 'agendado'
  | 'autorizar'
  | 'transporte'
  | 'implementar'
  | 'revisar';

export const SUBTASK_GATE_STATUS_OPTIONS: Array<{ value: ChangeSubtaskGateStatus; label: string }> =
  [
    { value: 'off', label: 'Desligado (padrão)' },
    { value: 'avaliar', label: labelChangeStatus('avaliar') },
    { value: 'agendado', label: labelChangeStatus('agendado') },
    { value: 'autorizar', label: labelChangeStatus('autorizar') },
    { value: 'transporte', label: labelChangeStatus('transporte') },
    { value: 'implementar', label: labelChangeStatus('implementar') },
    { value: 'revisar', label: labelChangeStatus('revisar') },
  ];
